import React from 'react';

export default function DotSkeleton() {
  return (
    <div className='tw-flex tw-h-full tw-w-full tw-animate-pulse tw-items-center tw-justify-center'>
      <div className='tw-inline-flex tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-grey-100' />
    </div>
  );
}
